import React, { Component } from 'react';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

import tableRequest from '../../models/tableRequest.js';
import DispatchReportService from '../../services/DispatchReportService';

import MessageComponent from '../../template/Message';
import Loaders from '../../template/Loaders';

export default class ObdBasedJsonReport extends Component {

    constructor(props) {
        super(props);

        this.DispatchReportService = new DispatchReportService();
        this.tblResponse = new tableRequest();

        this.state = {
            FromDate: new Date(),
            ToDate: new Date(),
            sales: [],
            loading: false,
            updateLoader: false,
            first: 0,
            rows: 10,
            totalRecords: 0,
            globalFilter: ''
        };
    }

    componentDidMount() {
        let date = new Date();
        date.setDate(date.getDate() - 7);

        this.setState({
            FromDate: date,
            ToDate: new Date()
        });

        this.tblResponse.FromDate = date.toLocaleDateString();
        this.tblResponse.ToDate = new Date().toLocaleDateString();
        this.tblResponse.PageSize = this.state.rows;
        this.tblResponse.First = this.state.rows;

        this.GetDispatch();
    }

    // ✅ PAGINATION FIX
    onPage = (event) => {

        const pageNo = Math.floor(event.first / event.rows) + 1;

        this.setState({
            first: event.first,
            rows: event.rows,
            loading: true,
            updateLoader: true
        });

        this.tblResponse.PageSize = event.rows;
        this.tblResponse.First = pageNo * event.rows;

        this.GetDispatch();
    };

    // ✅ SEARCH
    searchFilter = (e) => {
        this.tblResponse.SearchValue = e.target.value;

        this.setState({
            loading: true,
            updateLoader: true,
            first: 0
        });

        this.tblResponse.First = this.state.rows;

        this.GetDispatch();
    };

    // ✅ FILTER
    FilterData = () => {

        this.setState({
            loading: true,
            updateLoader: true,
            first: 0
        });

        this.tblResponse.FromDate = this.state.FromDate.toLocaleDateString();
        this.tblResponse.ToDate = this.state.ToDate.toLocaleDateString();
        this.tblResponse.First = this.state.rows;

        this.GetDispatch();
    };

    // ✅ API CALL
    GetDispatch = () => {

        this.DispatchReportService.GetOBDJsonReport(this.tblResponse)
            .then(res => {

                const data = res.data?.ResponseData || [];

                this.setState({
                    sales: data,
                    totalRecords: data.length > 0 ? data[0].TotalRows : 0,
                    loading: false,
                    updateLoader: false
                });
            })
            .catch(() => {
                this.setState({
                    sales: [],
                    totalRecords: 0,
                    loading: false,
                    updateLoader: false
                });
            });
    };

    // ✅ DOWNLOAD TXT
    downloadTemplate = (rowData) => {

        const downloadTxt = async () => {
            try {
                this.setState({ updateLoader: true });

                const res = await this.DispatchReportService.GetDispatchToPrint({
                    DeliveryNo: rowData.DeliveryNo
                });

                const data = res.data?.ResponseData || [];

                const grouped = {};

                data.forEach(item => {
                    if (!grouped[item.DeliveryNo]) {
                        grouped[item.DeliveryNo] = [];
                    }

                    grouped[item.DeliveryNo].push({
                        LINE_ITEM: parseInt(item.LineItem),
                        MATERIAL_CODE: item.MaterialNumber,
                        MATERIAL_DESCRIPTION: item.MaterialName,
                        BATCH: item.BatchNumber,
                        HIGH_LEVEL: parseInt(item.HighLevel),
                        STORAGE_LOCATION: item.StorageLocation,
                        QTY: parseFloat(item.TotalQty),
                        CASES: parseFloat(item.Cases),
                        SUBMITTED_BY: item.SubmittedBy,
                        SCANNED_BY: item.SubmittedBy
                    });
                });

                const finalJson = {
                    DELIVERY_LISTS: Object.keys(grouped).map(key => ({
                        DELIVERY_NO: key,
                        ITEMS: grouped[key]
                    }))
                };

                const blob = new Blob(
                    [JSON.stringify(finalJson, null, 2)],
                    { type: 'text/plain' }
                );

                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = `${rowData.DeliveryNo}.txt`;
                link.click();

                this.setState({ updateLoader: false });

            } catch (err) {
                this.setState({ updateLoader: false });
                this.refs.Messchild.showError("Download failed");
            }
        };

        return (
            <Button
                icon="pi pi-download"
                className="p-button-success"
                onClick={downloadTxt}
            />
        );
    };

    // ✅ HEADER UI FIXED
    renderHeader = () => (
        <div className="row align-items-center mb-3">

            <div className="col-md-8">
                <div className="d-flex gap-3 flex-wrap">

                    <div style={{ minWidth: "180px" }}>
                        <label>From Date</label>
                        <Calendar
                            value={this.state.FromDate}
                            onChange={(e) => this.setState({ FromDate: e.value })}
                            dateFormat="dd-mm-yy"
                            showIcon
                            className="w-100"
                        />
                    </div>

                    <div style={{ minWidth: "180px" }}>
                        <label>To Date</label>
                        <Calendar
                            value={this.state.ToDate}
                            onChange={(e) => this.setState({ ToDate: e.value })}
                            dateFormat="dd-mm-yy"
                            showIcon
                            className="w-100"
                        />
                    </div>

                    <div style={{ marginTop: "24px" , marginLeft: "10px"}}>
                        <Button label="Submit" onClick={this.FilterData} />
                    </div>

                </div>
            </div>

            <div className="col-md-4 text-end">
                <InputText
                    placeholder="Search"
                    onInput={this.searchFilter}
                    style={{ height: "38px", width: "200px" }}
                />
            </div>

        </div>
    );

    render() {

        return (
            <>
                <MessageComponent ref="Messchild" />
                {this.state.updateLoader && <Loaders loader={true} />}

                <h3>OBD Report</h3>

                <DataTable
                    value={this.state.sales}
                    paginator
                    lazy
                    first={this.state.first}
                    rows={this.state.rows}
                    totalRecords={this.state.totalRecords}
                    onPage={this.onPage}
                    loading={this.state.loading}
                    rowsPerPageOptions={[10, 20, 50]}
                    header={this.renderHeader()}
                >
                    <Column field="DeliveryNo" header="Delivery No" />
                    <Column field="DeliveryDate" header="Date" />
                    <Column field="Plant" header="Plant" />
                    <Column field="ShipToPartyName" header="Party" />
                    <Column field="Status" header="Status" />

                    {/* DOWNLOAD */}
                    <Column body={this.downloadTemplate} header="Download" />
                </DataTable>
            </>
        );
    }
}